import { MessageSquareOff, Clock, UserX, Sparkles } from "lucide-react";

const problems = [
  {
    icon: MessageSquareOff,
    title: "The Awkward Follow-Up",
    description: '"Hey, we met at... that event? I think you gave me your card?" — Nobody wants to send this email.',
    color: "text-destructive",
    bgColor: "bg-destructive/10",
  },
  {
    icon: Clock,
    title: "Timing is Everything",
    description: "By the time they dig out your card (if they kept it), the moment has passed. You're not top of mind anymore.",
    color: "text-amber-500",
    bgColor: "bg-amber-500/10",
  },
  {
    icon: UserX,
    title: "Forgettable First Impressions",
    description: "A paper card says 'I'm old school.' A messy LinkedIn says 'I don't take my brand seriously.' Neither works.",
    color: "text-muted-foreground",
    bgColor: "bg-muted",
  },
];

const ProblemSection = () => {
  return (
    <section className="py-24 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary/10 text-primary text-sm font-semibold mb-4">
            The Real Problem
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6">
            Networking is{" "}
            <span className="text-gradient">Broken</span>
          </h2>
          <p className="text-lg text-muted-foreground">
            You work hard to make great connections. But without a memorable, professional way to follow up, most of them fade away.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-16">
          {problems.map((problem, index) => (
            <div
              key={index}
              className="relative bg-card rounded-2xl p-8 border border-border hover:border-primary/30 transition-all duration-300 hover:shadow-xl hover:-translate-y-1"
            >
              {/* Icon */}
              <div className={`w-14 h-14 rounded-2xl ${problem.bgColor} flex items-center justify-center mb-6`}>
                <problem.icon className={`w-7 h-7 ${problem.color}`} />
              </div>
              
              {/* Content */}
              <h3 className="text-xl font-bold text-foreground mb-3">
                {problem.title}
              </h3>
              <p className="text-muted-foreground leading-relaxed">
                {problem.description}
              </p>
            </div>
          ))}
        </div>

        {/* Solution Teaser */}
        <div className="max-w-2xl mx-auto">
          <div className="relative bg-gradient-to-r from-primary/10 to-primary/5 rounded-3xl p-8 border border-primary/20 text-center">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary text-primary-foreground text-sm font-semibold">
                <Sparkles className="w-4 h-4" />
                The Solution
              </div>
            </div>
            <h3 className="text-2xl font-bold text-foreground mt-4 mb-3">
              Your Modern Professional Identity
            </h3>
            <p className="text-muted-foreground mb-6">
              One beautiful profile. All your info. Instantly shareable. <strong className="text-foreground">100% free to set up.</strong>
            </p>
            <div className="flex items-center justify-center gap-8 text-sm">
              <div className="flex items-center gap-2 text-primary">
                <span className="font-semibold">✓</span>
                <span>Professional & polished</span>
              </div>
              <div className="flex items-center gap-2 text-primary">
                <span className="font-semibold">✓</span>
                <span>Always up-to-date</span>
              </div>
              <div className="flex items-center gap-2 text-primary">
                <span className="font-semibold">✓</span>
                <span>One tap to share</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
